<template>
    <div id="app" class="min-w-[1024px] min-h-[100vh] flex">
        <ElementsTooltipSingleton
            :ref="
                (el) => {
                    loadTooltipElementReady(el);
                }
            " />
        <AppAside />
        <AppMain>
            <div>
                <h3 class="text-sm font-medium text-gray-500">FlexBen</h3>
                <h1 class="mt-1.5 text-3xl font-semibold flex items-center gap-1">
                    {{ title }}
                </h1>
            </div>
            <div v-if="$appUtil.checkPermission('DASHBOARD_EDIT')||$appUtil.checkPermission('DASHBOARD_VIEW')">

                <h1 class="text-[24px] text-[#2E2C34] font-bold mt-[24px] flex flex-row items-center">
                    <span>Points</span>
                </h1>
                <div class="mt-[10px] w-full max-w-7xl flex">
                    <div class="w-[24%] h-[8.75em] border shadow rounded box-style-border bg-[#fff] text-center mr-[17px]">
                        <p class="text-[16px] text-[#25324B] pt-[13px]">Total Topped-up Points(A+B)</p>
                        <div class="mt-[11px]">
                            <span class="text-[36px]">{{ numberWithCommas(topupSum) }}</span>
                            <span class="text-[16px] ml-1">points</span>
                        </div>
                    </div>
                    <div class="w-[24%] h-[8.75em] border shadow rounded box-style-border bg-[#fff] text-center mr-[17px]">
                        <p class="text-[16px] text-[#25324B] pt-[13px]">Available Points(A)</p>
                        <div class="mt-[11px]">
                            <span class="text-[36px]">{{ numberWithCommas(availableWalletAmount) }}</span>
                            <span class="text-[16px] ml-1">points</span>
                        </div>
                        <div class="mt-[1px]">
                            <div v-if="comparedToLastMonthAvailable > 0" class="flex justify-center items-center gap-2">
                                <div>
                                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5.20754 1.02938C5.60785 0.509372 6.39205 0.509372 6.79236 1.02938L11.6888 7.39002C12.195 8.04759 11.7262 9.00001 10.8964 9.00001H1.10353C0.273686 9.00001 -0.195076 8.04759 0.311121 7.39002L5.20754 1.02938Z"
                                            fill="#44CC82" />
                                    </svg>
                                </div>
                                <div class="text-[12px]">{{ comparedToLastMonthAvailable }}% compared to last month.</div>
                            </div>
                            <div v-else-if="comparedToLastMonthAvailable == 0" class="flex justify-center items-center gap-2">
                                <div>
                                    <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 11H11" stroke="#AAB0BA" stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                </div>
                                <div class="text-[12px]">{{ comparedToLastMonthAvailable }}% compared to last month.</div>
                            </div>
                            <div v-else class="flex justify-center items-center gap-2">
                                <div>
                                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M6.79258 8.60999C6.39228 9.13 5.60807 9.13 5.20777 8.60999L0.311344 2.24935C-0.194853 1.59178 0.273911 0.639358 1.10375 0.639359L10.8966 0.639359C11.7264 0.639359 12.1952 1.59178 11.689 2.24935L6.79258 8.60999Z"
                                            fill="#FF7777" />
                                    </svg>
                                </div>
                                <div class="text-[12px]">{{ -comparedToLastMonthAvailable }}% compared to last month.</div>
                            </div>
                        </div>
                    </div>

                    <div class="w-[24%] h-[8.75em] border shadow rounded box-style-border bg-[#fff] text-center mr-[17px]">
                        <p class="text-[16px] text-[#25324B] pt-[13px]">Transferred Points(B)</p>
                        <div class="mt-[11px]">
                            <span class="text-[36px]">{{ numberWithCommas(transSum) }}</span>
                            <span class="text-[16px] ml-1">points</span>
                        </div>
                        <div class="mt-[1px]">
                            <div v-if="comparedToLastMonthTransferred > 0" class="flex justify-center items-center gap-2">
                                <div>
                                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5.20754 1.02938C5.60785 0.509372 6.39205 0.509372 6.79236 1.02938L11.6888 7.39002C12.195 8.04759 11.7262 9.00001 10.8964 9.00001H1.10353C0.273686 9.00001 -0.195076 8.04759 0.311121 7.39002L5.20754 1.02938Z"
                                            fill="#44CC82" />
                                    </svg>
                                </div>
                                <div class="text-[12px]">{{ comparedToLastMonthTransferred }}% compared to last month.</div>
                            </div>
                            <div v-else-if="comparedToLastMonthTransferred == 0" class="flex justify-center items-center gap-2">
                                <div>
                                    <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 11H11" stroke="#AAB0BA" stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                </div>
                                <div class="text-[12px]">{{ comparedToLastMonthTransferred }}% compared to last month.</div>
                            </div>
                            <div v-else class="flex justify-center items-center gap-2">
                                <div>
                                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M6.79258 8.60999C6.39228 9.13 5.60807 9.13 5.20777 8.60999L0.311344 2.24935C-0.194853 1.59178 0.273911 0.639358 1.10375 0.639359L10.8966 0.639359C11.7264 0.639359 12.1952 1.59178 11.689 2.24935L6.79258 8.60999Z"
                                            fill="#FF7777" />
                                    </svg>
                                </div>
                                <div class="text-[12px]">{{ -comparedToLastMonthTransferred }}% compared to last month.</div>
                            </div>
                        </div>
                    </div>
                    <div class="w-[24%] h-[8.75em] border shadow rounded box-style-border bg-[#fff] text-center mr-[17px]">
                        <p class="text-[16px] text-[#25324B] pt-[13px]">Used Points</p>

                        <div class="mt-[11px]">
                            <span class="text-[36px]">{{ numberWithCommas(usedSum) }}</span>
                            <span class="text-[16px] ml-1">points</span>
                        </div>
                        <div class="mt-[1px]">
                            <div v-if="comparedToLastMonthUsed > 0" class="flex justify-center items-center gap-2">
                                <div>
                                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5.20754 1.02938C5.60785 0.509372 6.39205 0.509372 6.79236 1.02938L11.6888 7.39002C12.195 8.04759 11.7262 9.00001 10.8964 9.00001H1.10353C0.273686 9.00001 -0.195076 8.04759 0.311121 7.39002L5.20754 1.02938Z"
                                            fill="#44CC82" />
                                    </svg>
                                </div>
                                <div class="text-[12px]">{{ comparedToLastMonthUsed }}% compared to last month.</div>
                            </div>
                            <div v-else-if="comparedToLastMonthUsed == 0" class="flex justify-center items-center gap-2">
                                <div>
                                    <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 11H11" stroke="#AAB0BA" stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                </div>
                                <div class="text-[12px]">{{ comparedToLastMonthUsed }}% compared to last month.</div>
                            </div>
                            <div v-else class="flex justify-center items-center gap-2">
                                <div>
                                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M6.79258 8.60999C6.39228 9.13 5.60807 9.13 5.20777 8.60999L0.311344 2.24935C-0.194853 1.59178 0.273911 0.639358 1.10375 0.639359L10.8966 0.639359C11.7264 0.639359 12.1952 1.59178 11.689 2.24935L6.79258 8.60999Z"
                                            fill="#FF7777" />
                                    </svg>
                                </div>
                                <div class="text-[12px]">{{ -comparedToLastMonthUsed }}% compared to last month.</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex-1 mt-9 w-full max-w-7xl">
                    <div id="employees" class="mt-12">
                        <p class="text-[24px] text-[#2E2C34] font-bold mt-[24px]">Points Transfer Schedule</p>
                        <div class="mt-5 rounded bg-white shadow border box-style-border">
                            <div class="flex justify-between items-center h-[3.875rem]">
                                <h3 class="pl-5 text-base font-medium text-slate-500 w-[50px] text-center">No</h3>
                                <h3 class="py-4 text-base font-medium text-slate-500 flex-1 text-center">Date</h3>
                                <h3 class="py-4 text-base font-medium text-slate-500 flex-1 text-center">
                                    FlexBen <br />
                                    Type
                                </h3>
                                <h3 class="py-4 text-base font-medium text-slate-500 flex-1 text-center">
                                    Employee <br />
                                    Type
                                </h3>
                                <h3 class="py-4 text-base font-medium text-slate-500 flex-1 text-center">
                                    Transfer <br />
                                    Frequency
                                </h3>
                                <h3 class="py-4 text-base font-medium text-slate-500 flex-1 text-center">
                                    Distribution <br />
                                    Setting
                                </h3>
                                <h3 class="py-4 text-base font-medium text-slate-500 flex-1 text-center">
                                    Estimated <br/>
                                    Transfer Points
                                </h3>
                                <h3 class="py-4 text-base font-medium text-slate-500 flex-1 text-center">
                                    Transferred <br/>
                                    Status
                                </h3>
                                <h3 class="py-4 text-base font-medium text-slate-500 flex-1 text-center">
                                    Point <br/>
                                    Shortage
                                </h3>
                            </div>
                            <div class="w-full h-px bg-gray-200"></div>
                            <div class="overflow-auto">
                                <div class="min-w-full w-fit min-h-[8.5rem]">
                                    <div
                                        v-for="(event, index) in scheduleEvents"
                                        :key="index"
                                        href="javascript:void(0)"
                                        class="min-w-[656px] flex justify-between items-center py-2.5 w-full min-h-[4.25rem]"
                                        :class="{ 'bg-slate-50': index % 2 !== 0 }">
                                        <div class="pl-5 w-[50px] text-sm font-normal text-center truncate">
                                            {{ index + 1 }}
                                        </div>
                                        <div class="flex-1 text-sm font-normal text-center truncate">
                                            {{ fmtTimezoneToMMddyyyyHHmm(event.finishExecuteDateTime) }}
                                            {{ fmtTimezoneToMMddyyyyHHmm(event.executeDatetime) }}
                                        </div>
                                        <div class="flex-1 text-sm font-normal text-center truncate">
                                            {{ event.flexbenPolicyTransferName }}
                                        </div>
                                        <div class="flex-1 text-sm font-normal text-center truncate">
                                            <template v-if="setEmpType(event.employeeTypeCheckList).length == employeeTypes.length"> All </template>
                                            <template v-else>
                                                <template v-for="(empCheckType, index) in setEmpType(event.employeeTypeCheckList)" v-bind:key="index">
                                                    <!-- {{ setEmpType(event.employeeTypeCheckList) }} -->
                                                    <p>
                                                        {{ convertEmployeeTypeName(empCheckType) + (index !== setEmpType(event.employeeTypeCheckList).length - 1 ? ',' : '') }}
                                                    </p>
                                                </template>
                                            </template>
                                        </div>
                                        <div class="flex-1 text-sm font-normal text-center truncate">
                                            {{ convertPeriodTransferTypeName(event.periodTransferType) }}
                                        </div>
                                        <div class="flex-1 text-sm font-normal text-center truncate">
                                            {{ allocationTermsConverter(event.distributionTransferType) }}
                                        </div>
                                        <div class="flex-1 text-sm font-normal text-center truncate">
                                            {{ numberWithCommas( - (event.totalMileageVolume) ) }}
                                        </div>
                                        <div class="flex-1 text-sm font-normal text-center truncate">
                                            <template v-if="event.transferExecuteStatus == 'DONE'">
                                                <p class="text-[#037D43]">Success</p>
                                            </template>
                                            <template v-else-if="event.transferExecuteStatus == 'FAIL'">
                                                <p class="text-[#CC2525]">Fail</p>
                                            </template>
                                            <template v-else>
                                                <p class="text-[#41568B]">Pending</p>
                                            </template>
                                        </div>
                                        <div class="flex-1 text-sm font-normal text-center truncate">
                                            <template v-if="event.transferExecuteStatus == 'READY' && event.pointShortage != null">
                                                <template v-if="event.pointShortage">
                                                    <button @click="insufficientPoints">
                                                        <div class="bg-[#FCE1E1] rounded-[12px] inline-flex items-center py-1 px-2 text-[#CC2525]">
                                                            Insufficient
                                                            <img class="ml-1" src="@/assets/img/exclamation_red.svg" alt="" />
                                                        </div>
                                                    </button>
                                                </template>
                                                <template v-else>
                                                    <div class="bg-[#DCF8E6] rounded-[12px] inline-flex py-1 px-2 text-[#146E33]">Sufficient</div>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppMain>

        <Teleport to="body">
            <AppPopupHeaderless v-model="insufficientPointsPopup" title="Insufficient Points Alert" buttonText="Top up" @buttonEvent="openContactPopup">
                You have insufficient points to complete the transfer. <br />
                Top up your points now to proceed.
            </AppPopupHeaderless>
            <ContractPopup
                v-model="contactPopup"
            />
        </Teleport>
    </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
const { proxy } = getCurrentInstance();
const $api = proxy.$api;
const $axios = proxy.$axios;
import AppAside from '@/components/AppAside.vue';
import AppMain from '@/components/main/AppMain.vue';
import ElementsTooltipSingleton from '@/components/elements/ElementsTooltipSingleton.vue';
import AppPopupHeaderless from '@/components/AppPopupHeaderless';
import ContractPopup from '@/pages/flex_ben/topup/contract/contract-popup.vue';
import { useSummaryData } from './useSummaryData';
import { ref, computed, watch, onUnmounted } from 'vue';

const {
    title,
    availableWalletAmount,
    previousMonthMileage,
    topupSum,
    transSum,
    transferredSum,
    deductedSum,
    usedSum,
    thisMonthTransferredSum,
    thisMonthUsedSum,
    previousMonthTransferredSum,
    previousMonthUsedSum,
    scheduleEvents,
    insufficientPointsPopup,
    contactPopup,
    periodTransferTypes,
    employeeTypes,
    comparedToLastMonthAvailable,
    comparedToLastMonthTransferred,
    comparedToLastMonthUsed,
    numberWithCommas,
    fmtTimezoneToMMddyyyyHHmm,
    setEmpType,
    allocationTermsConverter,
    insufficientPoints,
    openContactPopup,
    convertPeriodTransferTypeName,
    convertEmployeeTypeName,
    loadTooltipElementReady
} = useSummaryData($api, $axios);

// 2) 하나라도 열려 있나?
const isAnyPopupOpen = computed(() => insufficientPointsPopup.value || contactPopup.value);

// 3) lock / unlock
let scrollYBackup = 0;
const lockBodyScroll = () => {
    scrollYBackup = window.scrollY || document.documentElement.scrollTop || 0;
    const body = document.body;
    body.style.position = 'fixed';
    body.style.top = `-${scrollYBackup}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
};
const unlockBodyScroll = () => {
    const body = document.body;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.style.overflow = '';
    window.scrollTo(0, scrollYBackup || 0);
};

// 4) 열림 상태 감시
watch(isAnyPopupOpen, (open) => {
    open ? lockBodyScroll() : unlockBodyScroll();
});

// 5) 컴포넌트가 사라질 때 깔끔히 해제
onUnmounted(unlockBodyScroll);

</script>

<style scoped>
.box-style-border {
    border: 1px solid #d1d5db;
}
</style>